var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTokeniki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 563.313,
    height: 142.742,
    viewBox: "0 0 563.313 142.742",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5778f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204bf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#204bf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5778ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(-142.808 -37.806)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "tokeniki",
    transform: "translate(340.121 143.308)",
    fill: "#050d17",
    fontSize: 100,
    fontFamily: "Outfit-Bold, Outfit",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "tokeniki")), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(142.808 37.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M12.651,11.068l0,0L4.178.867H.792L0,0,55.388.867l-42.734,10.2Z",
    transform: "translate(87.367 86.384)",
    fill: "#5072fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M0,10.825l.007-.007L.613,10.2H4.367L12.84,0,55.577,10.2.01,10.825Z",
    transform: "translate(55.577 97.452) rotate(180)",
    fill: "#243886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M0,11.086l.006-.007L.8,10.2H4.125L12.6,0,55.334,10.2.009,11.085Z",
    transform: "translate(87.42 45.288)",
    fill: "#243886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M12.615,10.75l0,0L4.143.549H.525L0,0,55.352.549,12.618,10.75Z",
    transform: "translate(55.352 56.038) rotate(180)",
    fill: "#5072fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M.618,55.422H.61L0,0,.61.486V4.41l8.549,7.757,1.045.952Z",
    transform: "translate(86.61 87.288)",
    fill: "#243886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M0,55.591v-.008L.578,0l9.594,42.334-1.045.951L.578,51.045v4.071l-.571.469Z",
    transform: "translate(56.112 142.74) rotate(180)",
    fill: "#5072fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M0,55.641v-.009L.075,0,9.669,42.334l-1.045.951L.075,51.045v4.442h.1l-.165.148Z",
    transform: "translate(87.145 0)",
    fill: "#5072fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6",
    "data-name": "Subtraction 6",
    d: "M.625,55.633H.617L0,0,.617.511v4.11l8.549,7.761,1.045.951Z",
    transform: "translate(56.151 55.666) rotate(180)",
    fill: "#243886"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M0,0H31.716V142.724H0Z",
    transform: "translate(55.504 0.018)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M0,0H31.716V142.724H0Z",
    transform: "translate(142.724 55.522) rotate(90)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTokeniki);
export default __webpack_public_path__ + "static/media/logo_tokeniki.45dc3ea323b783b7dadcbbfe4775ac67.svg";
export { ForwardRef as ReactComponent };